import React from 'react';
import { Modal, Form, Input, Button, Divider } from 'antd';

function CreateCalendar({ t, visible, loading, toggle, onFinish }) {
  return (
    <div className="create-calendar">
      <Modal
        className="upload-modal-content create-calendar-modal"
        width={250}
        title={t('create-calendar')}
        visible={visible}
        onCancel={toggle}
        footer={null}
      >
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            className="upload-modal-content__item"
            required
            name="name"
            label={t('calendar-name')}
          >
            <Input />
          </Form.Item>
          <Divider className="upload-modal-content__divider" />
          <div className="upload-modal-content__actions">
            <Button loading={loading} htmlType="submit" type="primary">
              {t('create-calendar')}
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
}

export default CreateCalendar;
